import module from 'fan/proyecto/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class FanProyectoColaboradoresEditarMigrarComponent {
  idProyecto
  filtro = ''
  proyectos = []
  colaboradores = []
  resultados = []
  seleccionados = []
  todosSeleccionados = true

  constructor ($q, FanProyectoColaboradoresProyectosService, FanProyectoColaboradoresMigrarColaboradoresService) {
    this.$q = $q
    this.FanProyectoColaboradoresProyectosService = FanProyectoColaboradoresProyectosService
    this.FanProyectoColaboradoresMigrarColaboradoresService = FanProyectoColaboradoresMigrarColaboradoresService
  }

  $onInit () {
    this.promise = this.$q.all([
      this.FanProyectoColaboradoresProyectosService.get(this.idProyecto)
        .then(({data}) => (this.proyectos = orderBy(data, ['descripcion']))),
      this.FanProyectoColaboradoresMigrarColaboradoresService.get(this.idProyecto)
        .then(({data}) => (this.colaboradores = orderBy(data, ['colaborador']))),
    ])
      .then(() => {
        this.colaboradores.forEach((item) => {
          item.seleccionable = item.rfc !== ''
          // item.seleccionado = item.seleccionable
          item.colaborador = normalizar(item.colaborador)
        })
        this.seleccionados = this.colaboradores.filter((item) => item.seleccionable)
        this.filtrar()
      })
  }

  filtrar () {
    if (this.filtro) {
      let filtro = normalizar(this.filtro)
      this.resultados = this.colaboradores.filter((item) => item.colaborador.contains(filtro))
    } else {
      this.resultados = [...this.colaboradores]
    }

    this.verificarTodosSeleccionados()
  }

  seleccionar (item) {
    if (!item.seleccionable) return
    item.seleccionado = !item.seleccionado
    this.seleccionados = this.colaboradores.filter((item) => item.seleccionado)
    this.verificarTodosSeleccionados()
  }

  seleccionarTodos () {
    this.todosSeleccionados = !this.todosSeleccionados
    this.resultados.forEach((item) => item.seleccionado = item.seleccionable && this.todosSeleccionados)
    this.seleccionados = this.colaboradores.filter((item) => item.seleccionado)
  }

  validar () {
    this.confirmar = true
  }

  verificarTodosSeleccionados () {
    this.todosSeleccionados = this.resultados.every(item => !item.seleccionable || item.seleccionado)
  }
}

module.component('fanProyectoColaboradoresEditarMigrar', {
  controller: FanProyectoColaboradoresEditarMigrarComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/migrar/component.js